import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useMapViewConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: crmModels.IMapViewConfig) => {
      const res = await $api.post('/v1/map-view-config', data);

      return res?.data?.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries(crmConstants.queryKeys.MAP_VIEW_CONFIG);
        qc.invalidateQueries(crmConstants.queryKeys.LEAD_MAP_VIEW);
      }
    }
  );
};
